import {
  IComponent,
  IComponentTab,
  IComponentPay,
  IComponentHot,
  IComponentText,
  IComponentCode,
  IComponentForm,
  IComponentDate,
  IComponentTime,
  IComponentVote,
  IComponentGuide,
  IComponentImage,
  IComponentVideo,
  IComponentInput,
  IComponentPhone,
  IComponentRadio,
  IComponentLucky,
  IComponentEmpty,
  IComponentPhoto,
  IComponentGuests,
  IComponentVideoH,
  IComponentIFrame,
  IComponentInvite,
  IComponentSelect,
  IComponentPendent,
  IComponentGallery,
  IComponentFormOcr,
  IComponentActInfo,
  IComponentActFlow,
  IComponentContact,
  IComponentLiveCut,
  IComponentCollapse,
  IComponentTextarea,
  IComponentPassword,
  IComponentCheckbox,
  IComponentDocument,
  IComponentLiveShow,
  IComponentCarousel,
  IComponentLiveRich,
  IComponentSlideHead,
  IComponentVideoHead,
  IComponentHVideoList,
  IComponentMultiVideo,
  IComponentInviteUser,
  IComponentButtonGroup,
  IComponentCommentSend,
  IComponentCommentList,
  IComponentMobileUpload,
  IComponentGroupGallery,
} from 'component';
import { setContainer } from 'utils/dom';
import { ThemeContext } from 'store/ThemeProvider';
import React, { CSSProperties, useContext } from 'react';
import { ComponentMultiVideoV2 } from 'components/ComponentMultiVideoV2';
import AllForGroupGallery from 'components/ComponentGroupGallery/AllForGroupGallery';
import AllForExhibitor from '../ComponentExhibitor/AllForExhibitor';
import ExhibitorCard from '../ComponentExhibitor/ExhibitorCard';

import AllForTab from '../ComponentTab/AllForTab';
import AllForOcr from '../ComponentOcr/AllForOcr';
import AllForHot from '../ComponentHot/AllForHot';
import AllForTips from '../ComponentTips/AllForTips';
import AllForCode from '../ComponentCode/AllForCode';
import AllForForm from '../ComponentForm/AllForForm';
import AllForVote from '../ComponentVote/AllForVote';
import AllForFormPay from '../ComponentForm/AllForPay';
import AllForXHead from '../ComponentXHead/AllForXHead';
import AllForImage from '../ComponentImage/AllForImage';
import AllForVideo from '../ComponentVideo/AllForVideo';
import AllForLucky from '../ComponentLucky/AllForLucky';
import AllForHotPic from '../ComponentHot/AllForHotPic';
import AllForEmpty from '../ComponentEmpty/AllForEmpty';
import AllForText from '../ComponentRichText/AllForText';
import AllForFormDate from '../ComponentForm/AllForDate';
import AllForFormTime from '../ComponentForm/AllForTime';
import AllForGuests from '../ComponentGuests/AllForGuests';
import AllForVideoH from '../ComponentVideoH/AllForVideoH';
import AllForIFrame from '../ComponentIFrame/AllForIFrame';
import AllForFormInput from '../ComponentForm/AllForInput';
import AllForFormPhone from '../ComponentForm/AllForPhone';
import AllForFormRadio from '../ComponentForm/AllForRadio';
import AllForInvite from '../ComponentInvite/AllForInvite';
import AllForFormSelect from '../ComponentForm/AllForSelect';
import AllForFormInvite from '../ComponentForm/AllForInvite';
import AllForGallery from '../ComponentGallery/AllForGallery';
import AllForLeadingPage from '../ComponentGuide/AllForGuide';
import AllForActInfo from '../ComponentActInfo/AllForActInfo';
import AllForActFlow from '../ComponentActFlow/AllForActFlow';
import AllForContact from '../ComponentContact/AllForContact';
import AllForLiveCut from '../ComponentLiveCut/AllForLiveCut';
import AllForVideoHead from '../ComponentXHead/AllForVideoHead';
import AllForButtonGroup from '../ButtonGroup/AllForButtonGroup';
import AllForLiveRich from '../ComponentLiveRich/AllForLiveRich';
import AllForFormTextarea from '../ComponentForm/AllForTextarea';
import AllForFormCheckbox from '../ComponentForm/AllForCheckbox';
import AllForFormPassword from '../ComponentForm/AllForPassword';
import AllForDocument from '../ComponentDocument/AllForDocument';
import AllForLiveShow from '../ComponentLiveShow/AllForLiveShow';
import AllForCarousel from '../ComponentCarousel/AllForCarousel';
import AllForPendantV2 from '../ComponentPendantV2/AllForPendant';
import AllForAccordion from '../ComponentCollapse/AllForAccordion';
import GalleryListWrapper from '../GalleryList/GalleryListWrapper';
import AllForImageBottom from '../ComponentImageBottom/AllForImage';
import AllForHVideoList from '../ComponentHVideoList/AllForHVideoList';
import AllForMultiVideo from '../ComponentMultiVideo/AllForMultiVideo';
import AllForCommentSend from '../ComponentCommentSend/AllForCommentSend';
import AllForCommentList from '../ComponentCommentList/AllForCommentList';
import AllForMobileUpload from '../ComponentMobileUpload/AllForMobileUpload';
import AllForPortrait from '../ComponentForm/AllForPortrait';
import { IComponentPortrait } from 'component';

// noinspection JSUnusedLocalSymbols
const RenderComponent = (
  component: IComponent,
  renderMode: string = 'mobile',
  extraProps: any = {}
) => {
  const { type } = component;
  switch (type) {
    case 'videohead':
      return <AllForVideoHead {...(component as IComponentVideoHead)} />;
    case 'slidehead':
      return <AllForXHead {...(component as IComponentSlideHead)} />;
    case 'pendent':
      // return null; // pendent 这种 position:fixed 的组件，不能渲染在swiper内
      // return renderMode == 'pc' ? <AllForPendantV2 {...component as IComponentPendent} /> : null;
      return <AllForPendantV2 {...(component as IComponentPendent)} />;
    // navigator比较特殊，在外层处理了，所以这里不做任何渲染
    case 'navigator':
      return null;
    // return <AllForNavigator {...component as IComponentNavigator} />;
    // gallery-list也是一个特殊的东西，单独处理，这里不做渲染
    case 'photo':
      return <GalleryListWrapper component={component as IComponentPhoto} {...extraProps} />;
    case 'guide':
      return <AllForLeadingPage {...(component as IComponentGuide)} />;
    case 'tab':
      return <AllForTab {...(component as IComponentTab)} />;
    case 'image':
      return <AllForImage {...(component as IComponentImage)} />;
    case 'image_bottom':
      return <AllForImageBottom {...(component as IComponentImage)} />;
    case 'richtext':
      return <AllForText {...(component as IComponentText)} />;
    case 'liverich':
      return <AllForLiveRich {...(component as IComponentLiveRich)} />;
    case 'buttongroup':
      return <AllForButtonGroup {...(component as IComponentButtonGroup)} />;
    case 'video':
      return <AllForVideo {...(component as IComponentVideo)} />;
    case 'gallery':
      return <AllForGallery {...(component as IComponentGallery)} />;
    case 'collapse':
      return <AllForAccordion {...(component as IComponentCollapse)} />;
    case 'formocr':
      return <AllForOcr {...(component as IComponentFormOcr)} />;
    case 'tips':
      return <AllForTips {...(component as IComponent)} />;
    case 'actinfo':
      return <AllForActInfo {...(component as IComponentActInfo)} />;
    case 'guests':
      return <AllForGuests {...(component as IComponentGuests)} />;
    case 'actflow':
      return <AllForActFlow {...(component as IComponentActFlow)} />;
    case 'hvideolist':
      return <AllForHVideoList {...(component as IComponentHVideoList)} />;
    case 'videoh':
      return <AllForVideoH {...(component as IComponentVideoH)} />;
    case 'commentsend':
      return <AllForCommentSend {...(component as IComponentCommentSend)} />;
    case 'commentlist':
      return <AllForCommentList {...(component as IComponentCommentList)} />;
    case 'iframe':
      return <AllForIFrame {...(component as IComponentIFrame)} />;
    case 'code':
      return <AllForCode {...(component as IComponentCode)} />;
    case 'form':
      return <AllForForm {...(component as IComponentForm)} />;
    case 'form_input':
      return <AllForFormInput {...(component as IComponentInput)} />;
    case 'form_phone':
      return <AllForFormPhone {...(component as IComponentPhone)} />;
    case 'form_textarea':
      return <AllForFormTextarea {...(component as IComponentTextarea)} />;
    case 'form_date':
      return <AllForFormDate {...(component as IComponentDate)} />;
    case 'form_time':
      return <AllForFormTime {...(component as IComponentTime)} />;
    case 'form_radio':
      return <AllForFormRadio {...(component as IComponentRadio)} />;
    case 'form_checkbox':
      return <AllForFormCheckbox {...(component as IComponentCheckbox)} />;
    case 'form_select':
      return <AllForFormSelect {...(component as IComponentSelect)} />;
    case 'form_invite':
      return <AllForFormInvite {...(component as IComponentInvite)} />;
    case 'form_password':
      return <AllForFormPassword {...(component as IComponentPassword)} />;
    case 'form_pay':
      return <AllForFormPay {...(component as IComponentPay)} />;
    case 'form_portrait':
      return <AllForPortrait {...(component as IComponentPortrait)} />;
    case 'document':
      return <AllForDocument {...(component as IComponentDocument)} />;
    case 'vote':
      return <AllForVote {...(component as IComponentVote)} />;
    case 'contact':
      return <AllForContact {...(component as IComponentContact)} />;
    case 'hot':
      return <AllForHot {...(component as IComponentHot)} />;
    case 'hot_pic':
      return <AllForHotPic {...(component as IComponentHot)} />;
    case 'carousel':
      return <AllForCarousel {...(component as IComponentCarousel)} />;
    case 'exhibitor':
      return <AllForExhibitor {...(component as any)} />;
    case 'exhibitorcard':
      return <ExhibitorCard {...(component as any)} />;
    case 'empty':
      return <AllForEmpty {...(component as IComponentEmpty)} />;
    case 'multi_video':
      return <AllForMultiVideo {...(component as IComponentMultiVideo)} />;
    case 'lucky':
      return <AllForLucky {...(component as IComponentLucky)} />;
    case 'liveshow':
      return <AllForLiveShow {...(component as IComponentLiveShow)} />;
    case 'livecut':
      return <AllForLiveCut {...(component as IComponentLiveCut)} />;
    case 'multivideov2':
      return <ComponentMultiVideoV2 {...(component as IComponent)} />;
    case 'invite':
      return <AllForInvite {...(component as IComponentInviteUser)} />;
    case 'mobileupload':
      return <AllForMobileUpload {...(component as IComponentMobileUpload)} />;
    case 'gallerygroup':
    case 'groupgallery':
      return <AllForGroupGallery {...(component as IComponentGroupGallery)} />;
    default:
      console.warn('unknown type', type, component);
      return null;
  }
};

export const RenderComponentWithWrapper = (component: IComponent & { visible?: boolean }) => {
  const themeContext = useContext(ThemeContext);
  const { componentColor } = themeContext;
  // commentsend不需要在这里构建他的样式
  const style =
    component.type === 'commentsend'
      ? {}
      : (setContainer(component, componentColor) as CSSProperties);
  // console.log(component, style)

  return (
    <div className={`comp_${component.cid} comp-type-${component.type}`} key={component.cid} style={style}>
      {RenderComponent(component, 'mobile', { visible: component.visible })}
    </div>
  );
};

export const RenderComponentWithPCWrapper = (component: IComponent & { visible?: boolean }) => {
  const themeContext = useContext(ThemeContext);
  const { componentColor } = themeContext;
  // commentsend不需要在这里构建他的样式
  const style =
    component.type === 'commentsend'
      ? {}
      : (setContainer(component, componentColor) as CSSProperties);

  return (
    <div className={`comp_${component.cid} comp-type-${component.type}`} key={component.cid} style={style}>
      {RenderComponent(component, 'pc', { visible: component.visible })}
    </div>
  );
};

export default RenderComponent;
